<template>
  <v-field :label='label' :error='errors.first(name)' :name="name" :tooltip='tooltipMsg'>
    <v-multiselect
      :options="options"
      :name="name"
      :value='realValue'
      :label='labelField'
      :track-by="valueField"
      :showLabels="false"
      :allow-empty='allowEmpty'
      :close-on-select="true"
      placeholder="Sélectionner une valeur"
      v-bind='$attrs'
      v-on='inputListeners'
      :disabled="$can.not('edit-exploitation')"
    >
      <template slot='noResult'>
        Aucune donnée correspondante
      </template>
    </v-multiselect>
    <slot />
  </v-field>
</template>

<script>
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'FieldSelect',

  inheritAttrs: false,
  inject: ['$validator'],
  mixins: [mixinTooltip],

  props: {
    value: {
      type: [Number, Object]
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    labelField: {
      type: String,
      default: 'label'
    },
    valueField: {
      type: String,
      default: 'value'
    },
    allowEmpty: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    realValue () {
      if (this.valueField === '') {
        return this.value
      }
      return this.options.find(o => o[this.valueField] === this.value)
    },

    inputListeners: function () {
      var vm = this
      // `Object.assign` merges objects together to form a new object
      return Object.assign({},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function (val) {
            if (!val) {
              vm.$emit('input', null)
            }
            if (val instanceof Object) {
              if (vm.valueField === '') {
                vm.$emit('input', val)
              } else {
                val = val[vm.valueField]
              }
            }
            let value = parseInt(val)
            if (!isNaN(value)) {
              vm.$emit('input', value)
            }
          }
        }
      )
    }
  }
}
</script>
